import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const blockSender = loginId =>
    RESTClient.postAuthenticatedObservable('v2/posts/sender-blocks', {
        sender: loginId,
    });

export const unblockSender = loginId =>
    RESTClient.deleteAuthenticatedObservable('v2/posts/sender-blocks', {
        sender: loginId,
    });

export const getBlockedSenders = () =>
    RESTClient.getAuthenticatedObservable('v2/posts/sender-blocks').map(({senderBlocks}) => List(senderBlocks));
